(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colorway-switcher"] && !Shopify.designMode) return;
  try {
    
  class ColorwaySwitcher extends HTMLElement {
    connectedCallback() {
      this.frames = Array.from(this.querySelectorAll('[data-colorway-frame]'));
      this.swatches = Array.from(this.querySelectorAll('[data-colorway-swatch]'));
      this.label = this.querySelector('[data-colorway-name]');
      if (this.frames.length < 2) return;

      this.index = 0;
      this.timer = null;
      const firstColor = getComputedStyle(this.swatches[0]).getPropertyValue('--swatch');
      if (firstColor) this.style.setProperty('--current-swatch', firstColor.trim());
      this.paused = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
      this.interval = Math.max(1200, parseInt(this.dataset.interval, 10) || 3000);

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          this.select(Number(swatch.dataset.index));
          this.autoplay = false; // the visitor is driving now
          this.stop();
        });
      });

      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('pointerenter', () => this.pause());
      this.addEventListener('pointerleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());

      document.addEventListener('visibilitychange', this.onVisibility);

      // The ticker starts immediately but only advances while the section is on
      // screen — otherwise it would cycle past lazy-loaded frames that haven't
      // downloaded yet and land on a blank one when the visitor scrolls down.
      this.start();

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) this.preload();
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
    }

    onVisibility = () => {
      if (document.hidden) this.stop();
      else this.start();
    };

    /** Warm every frame once the section is close, so switching never flashes. */
    preload() {
      if (this.preloaded) return;
      this.preloaded = true;
      this.frames.forEach((frame) => {
        frame.loading = 'eager';
        if (!frame.complete) new Image().src = frame.currentSrc || frame.src;
      });
    }

    onScreen() {
      const rect = this.getBoundingClientRect();
      const height = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 0 && rect.top < height;
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.observer) this.observer.disconnect();
    }

    select(index) {
      if (index === this.index) return;
      this.frames[this.index]?.classList.remove('is-active');
      this.swatches[this.index]?.setAttribute('aria-pressed', 'false');
      this.index = index;
      this.frames[index]?.classList.add('is-active');
      this.swatches[index]?.setAttribute('aria-pressed', 'true');
      const swatch = this.swatches[index];
      const name = swatch?.textContent.trim();
      if (this.label && name) this.label.textContent = name;
      const color = swatch && getComputedStyle(swatch).getPropertyValue('--swatch');
      if (color) this.style.setProperty('--current-swatch', color.trim());
    }

    onKeydown = (event) => {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      const step = keys[event.key];
      if (!step || !this.contains(document.activeElement)) return;
      if (!document.activeElement.matches('[data-colorway-swatch]')) return;
      event.preventDefault();
      const next = (this.index + step + this.frames.length) % this.frames.length;
      this.select(next);
      this.swatches[next].focus();
    };

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => {
        if (document.hidden || !this.onScreen()) return;
        this.preload();
        this.select((this.index + 1) % this.frames.length);
      }, this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    pause() {
      this.paused = true;
      this.stop();
    }

    resume() {
      this.paused = false;
      this.start();
    }
  }

  if (!customElements.get('colorway-switcher')) {
    customElements.define('colorway-switcher', ColorwaySwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
